<template>
    <main>

        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="/home" title="Home">Home</a></li>
                            <li>Realizar Testes / Entrevistas</li>
                        </ul>
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Realizar Testes / Entrevistas</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form ref="colaborador-form-create" v-on:submit.prevent novalidate>
                            <div class="row justify-content-center">
                                <div class="col-md-auto">
                                    <div class="form-group">
                                        <label for="cpf">Digite o CPF do candidato</label>
                                        <input type="text" class="form-control" name="cpf" v-mask="mask_cpf" maxlength="14" autocomplete="off" placeholder="___.___.___-__" v-model="cpfBusca" required />
                                    </div>
                                    <button type="button" class="btn btn-success " @click="verificarCPF()">
                                        <span>Verificar</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="mold-txt-center" v-if="colaborador">
                        <div class="row">
                            <div class="form-group col-md-8">
                                <strong for="nmCompleto">Nome Completo</strong>
                                <p>{{ colaborador.nmCompleto }}</p>
                            </div>
                            <div class="form-group col-md-4">
                                <strong>Apelido</strong>
                                <p>{{ colaborador.apelido }}</p>
                            </div>

                            <div class="form-group col-md-4">
                                <strong for="email">E-mail</strong>
                                <p>{{ colaborador.email }}</p>
                            </div>
                            <div class="form-group col-md-4">
                                <strong for="emailAlternativo">E-mail Alternativo</strong>
                                <p>{{ colaborador.emailAlternativo }}</p>
                            </div>
                            <div class="form-group col-md-4">
                                <strong for="dtNascimento">Nascimento</strong>
                                <p>{{ colaborador.dtNascimento }}</p>
                            </div>

                            <div class="form-group col-md-4">
                                <strong for="cpf">CPF</strong>
                                <p>{{ colaborador.cpf }}</p>
                            </div>
                            <div class="form-group col-md-4">
                                <strong for="rg">RG</strong>
                                <p>{{ colaborador.rg }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="mold-txt-center">
                        <candidato-content  v-if="colaborador" :escola-id="escolaLogadaId" :colaborador-id="colaborador.colaboradorId" @on-back="onBack()" />
                    </div>

                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogMensagem" :hide-footer="true" title="Atenção">
            <p>Nenhum candidato foi encontrado com este CPF</p>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import auth from '@/common/auth'
    import { Api } from '@/common/api'

    import candidatoContent from './content'

    export default {
        name: 'candidato',
        mixins: [base],
        components: {
            candidatoContent,
        },
        props: {},
        data() {
            return {
                cpfBusca: '',
                escolaLogadaId: 0,
                colaborador: null,

                dialogMensagem: false,

            }
        },
        methods: {
            verificarCPF: function () {

                this.colaborador = null;

                new Api('colaborador/verificacpfcolaborador').get({
                    cpf: this.cpfBusca.replace(/\D+/g, '')
                }).then(result => {

                    this.onBack();

                    let _data = result.data;

                    if (!_data || _data.colaboradorNaoEncontrado) {
                        this.dialogMensagem = true;
                        return;
                    }

                    this.colaborador = _data.colaborador;

                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            onBack: function () {
                this.colaborador = null;
                this.dialogConfigurarAcesso = false;
                this.mensagemAdicionalConfirmacao = '';
                this.cpfBusca = '';
            }

        },

        mounted() {
            this.escolaLogadaId = +auth.currentUser().tenant;
        }

    };
</script>